import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import CheckImg from "../images/check-mark.svg";
import { Link } from "react-router-dom";

function CheckSentProject({ type = "project" }) {
  return (
    <Stack pt={2}>
      <Box
        sx={{
          width: { xs: 105, sm: 120, lg: 130 },
          textAlign: "center",
          marginInline: "auto",
          mb: 2,
        }}
      >
        <img src={CheckImg} style={{ width: "100%", height: "100%" }} />
      </Box>
      <Typography component="h1" variant="h5" textAlign="center" mb={3}>
        ¡{type === "project" ? "PROYECTO" : "INMUEBLE"} ENVIADO!
      </Typography>
      <Typography
        fontSize="large"
        sx={{
          fontWeight: "normal",
          textAlign: "center",
          width: { xs: "95%", md: "50%" },
          marginInline: "auto",
          mb: 4,
        }}
      >
        Perfecto, tu {type === "project" ? "proyecto" : "inmueble"} ha sido
        enviado a revisión, pronto te avisaremos si fue aprobado. Gracias por
        usar Invirte!
      </Typography>
      <Button
        variant="contained"
        LinkComponent={Link}
        to={"/"}
        sx={{
          width: "fit-content",
          px: 4,
          marginInline: "auto",
          color: "white",
        }}
      >
        REGRESAR
      </Button>
    </Stack>
  );
}

export default CheckSentProject;
